<template>
  <div class="device-manage-page">
    <management-table
      title="设备管理"
      eyebrow="Device Manage"
      table-class="device-index-table"
      :data="tableData"
      :loading="loading"
      :current-page="query.pageNum"
      :page-size="query.pageSize"
      :total="total"
      empty-text="暂无设备数据"
      @current-change="onPageChange"
    >
      <template slot="filters">
        <div class="search-item">
          <label class="search-label">电站名称:</label>
          <el-select
            v-model="query.stationId"
            clearable
            filterable
            :filter-method="filterSearchStation"
            @visible-change="onSearchStationDropdownVisible"
            placeholder="请选择或输入电站名称"
            class="search-select"
          >
            <el-option
              v-for="item in stationFilterList"
              :label="item.stationName"
              :key="item.id"
              :value="item.id"
            />
          </el-select>
        </div>
        <div class="search-item">
          <label class="search-label">设备名称:</label>
          <el-select 
            v-model="query.id" 
            clearable 
            filterable
            placeholder="请选择设备名称"
            class="search-select"
          >
            <el-option v-for="item in deviceList" :label="item.deviceName" :key="item.id" :value="item.id" />
          </el-select>
        </div>
        <div class="search-item">
          <label class="search-label">设备类型:</label>
          <el-select 
            v-model="query.stationType" 
            placeholder="请选择设备类型" 
            clearable 
            class="search-select"
          >
            <el-option value="1" label="控制器" />
            <el-option value="2" label="电表" />
          </el-select>
        </div>
        <div class="search-item">
          <label class="search-label">设备状态:</label>
          <el-select 
            v-model="query.deviceStatus" 
            placeholder="请选择设备状态" 
            clearable  
            class="search-select"
          >
            <el-option value="1" label="离线" />
            <el-option value="2" label="在线" />
            <el-option value="3" label="故障" />
            <el-option value="4" label="报警" />
          </el-select>
        </div>
      </template>
      <template slot="actions">
        <el-button type="primary" icon="el-icon-search" @click="serch" class="search-btn">搜索</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="addDevice" class="add-btn" v-if="canEdit === 1">新增设备</el-button>
      </template>
      <template slot="columns">
          <el-table-column label="电站名称" width="150" show-overflow-tooltip prop="stationName" />
          <el-table-column label="设备名称" width="150" show-overflow-tooltip prop="deviceName" />
          <el-table-column label="串号" width="140" show-overflow-tooltip prop="serNo" />
          <el-table-column label="版本号" width="120" show-overflow-tooltip prop="versionNo" />
          <el-table-column label="物联网卡号" width="160" show-overflow-tooltip prop="iccid" />
          <el-table-column label="型号" width="120" show-overflow-tooltip prop="typeNo" />
          <el-table-column label="设备地址" width="180" show-overflow-tooltip prop="address" />
          <el-table-column label="设备类型" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.deviceType == 1">控制器</span>
              <span v-if="scope.row.deviceType == 2">电表</span>
              <span v-if="scope.row.deviceType == 3">逆变器</span>
            </template>
          </el-table-column>
          <el-table-column label="网络状态" width="120">
            <template slot-scope="scope">
              <el-tag type="success" class="tag-online" v-if="scope.row.deviceStatus == 2">在线</el-tag>
              <el-tag type="danger" class="tag-offline" v-if="scope.row.deviceStatus == 1">离线</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="连接时间" width="160" show-overflow-tooltip prop="lastConnetTime" />
          <el-table-column v-if="!isMobileViewport" label="操作" fixed="right" width="380">
            <template slot-scope="scope">
              <div class="opt-group">
                <span class="opt-btn" @click="infoView(scope.row.id);formTitle='查看设备'">查看</span>
                <span class="opt-btn" @click="infoView(scope.row.id);formTitle='编辑设备'" v-if="canEdit === 1">编辑</span>
                <span class="opt-btn del-btn" @click="deleteRow(scope.row.id)" v-if="canEdit === 1">删除</span>
                <span class="opt-btn" @click="seekzqForm = true;optId=scope.row.id" v-if="scope.row.deviceType == 1">控制器数据</span>
                <span class="opt-btn" @click="seedbForm = true;optId=scope.row.id" v-if="scope.row.deviceType == 2">电表数据</span>
                <el-popover
                  placement="bottom-start"
                  :ref="'popover'+scope.$index"
                  trigger="click"
                  v-if="scope.row.deviceType == 1 && canEdit === 1"
                >
                  <div class="popover-content">
                    <div v-for="(item1,index) in statusList" 
                      @click="subEditForm(index+1,scope.row.serNo,item1)"
                      class="popover-item"
                    >
                      {{item1}}
                    </div>
                  </div> 
                  <span slot="reference" class="opt-btn dropdown-btn">
                    设备控制<i class="el-icon-arrow-down" />
                  </span>
                </el-popover>	
              </div>
            </template>
          </el-table-column>
          <el-table-column v-else label="操作" fixed="right" width="84" align="center">
            <template slot-scope="scope">
              <el-dropdown
                trigger="click"
                placement="bottom-end"
                @command="handleMobileCommand($event, scope.row)"
              >
                <button type="button" class="mobile-action-trigger">
                  <i class="el-icon-more"></i>
                  <span>操作</span>
                </button>
                <el-dropdown-menu slot="dropdown" class="device-mobile-actions-menu">
                  <el-dropdown-item command="view" icon="el-icon-view">查看设备</el-dropdown-item>
                  <el-dropdown-item v-if="canEdit === 1" command="edit" icon="el-icon-edit">编辑设备</el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.deviceType == 1"
                    command="controllerData"
                    icon="el-icon-data-analysis"
                  >控制器数据</el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.deviceType == 2"
                    command="meterData"
                    icon="el-icon-data-analysis"
                  >电表数据</el-dropdown-item>
                  <template v-if="scope.row.deviceType == 1 && canEdit === 1">
                    <el-dropdown-item
                      v-for="(item, index) in statusList"
                      :key="'control-' + index"
                      :command="'control:' + index"
                      :divided="index === 0"
                      icon="el-icon-setting"
                    >{{ item }}</el-dropdown-item>
                  </template>
                  <el-dropdown-item
                    v-if="canEdit === 1"
                    command="delete"
                    divided
                    icon="el-icon-delete"
                    class="device-mobile-delete-action"
                  >删除设备</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
      </template>
    </management-table>

    <!-- 设备新增/编辑/查看弹窗 -->
    <el-dialog
      :title="formTitle"
      :visible.sync="showAdd"
      width="850px"
      custom-class="device-dialog mobile-form-dialog"
      :close-on-click-modal="false"
    >
      <!-- 表单绑定中文校验规则 -->
      <el-form 
        ref="formObjectForm" 
        :model="addFormObject" 
        size="medium" 
        :label-position="isMobileViewport ? 'top' : 'right'"
        :label-width="isMobileViewport ? 'auto' : '90px'"
        :class="['blue-form', {'detail-view-form': formTitle == '查看设备'}]"
        :rules="formTitle == '查看设备' ? {} : formRules"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="设备名称" prop="deviceName">
              <el-input 
                v-model="addFormObject.deviceName" 
                maxlength="50" 
                placeholder="请输入设备名称"
                v-if="formTitle!='查看设备'"
                class="dialog-input"
              />
              <span v-if="formTitle=='查看设备'">{{addFormObject.deviceName}}</span>
            </el-form-item>	  
          </el-col>
          <el-col :span="12">
            <el-form-item label="串号" prop="serNo">
              <el-input 
                v-model="addFormObject.serNo" 
                maxlength="50" 
                placeholder="请输入串号" 
                v-if="formTitle!='查看设备'"
                class="dialog-input"
              />
              <span v-if="formTitle=='查看设备'">{{addFormObject.serNo}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="版本号" prop="versionNo">
              <el-input 
                v-model="addFormObject.versionNo" 
                maxlength="50" 
                placeholder="请输入版本号" 
                v-if="formTitle!='查看设备'"
                class="dialog-input"
              />
              <span v-if="formTitle=='查看设备'">{{addFormObject.versionNo}}</span>
            </el-form-item>	  
          </el-col>
          <el-col :span="12">
            <el-form-item label="型号" prop="typeNo">
              <el-input 
                v-model="addFormObject.typeNo" 
                maxlength="50" 
                placeholder="请输入型号" 
                v-if="formTitle!='查看设备'"
                class="dialog-input"
              />
              <span v-if="formTitle=='查看设备'">{{addFormObject.typeNo}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="电站" prop="powerStationId">
              <el-select 
                v-model="addFormObject.powerStationId"
                placeholder="请选择电站"
                clearable
                filterable
                :filter-method="filterStation"
                v-if="formTitle!='查看设备'"
                class="dialog-select"
              >
                <el-option :value="item.id" :label="item.stationName" :key="item.id" v-for="item in stationList" />
              </el-select>
              <span v-if="formTitle=='查看设备'">{{addFormObject.stationName}}</span>
            </el-form-item>	  
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备地址" prop="address">
              <el-input 
                v-model="addFormObject.address" 
                maxlength="50" 
                placeholder="请输入设备地址" 
                v-if="formTitle!='查看设备'"
                class="dialog-input"
              />
              <span v-if="formTitle=='查看设备'">{{addFormObject.address}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="设备类型" prop="deviceType">
              <el-select 
                v-model="addFormObject.deviceType" 
                placeholder="请选择设备类型" 
                clearable 
                v-if="formTitle!='查看设备'"
                class="dialog-select"
              >
                <el-option value="1" label="控制器" />
                <el-option value="2" label="电表" />
                <el-option value="3" label="逆变器" />
              </el-select>
              <span v-if="formTitle=='查看设备'">
                <span v-if="addFormObject.deviceType == 1">控制器</span>
                <span v-if="addFormObject.deviceType == 2">电表</span>
                <span v-if="addFormObject.deviceType == 3">逆变器</span>
              </span>
            </el-form-item>	  
          </el-col>
          <el-col :span="12">
            <el-form-item label="物联网卡" prop="iccid">
              <el-input 
                v-model="addFormObject.iccid" 
                maxlength="50" 
                placeholder="请输入物联网卡号（选填）"
                v-if="formTitle!='查看设备'"
                class="dialog-input"
              />
              <span v-if="formTitle=='查看设备'">{{addFormObject.iccid || '未填写'}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="formTitle=='查看设备'">
          <el-col :span="12">
            <el-form-item label="网络状态" prop="deviceStatus">
              <el-tag type="danger" class="tag-offline" v-if="addFormObject.deviceStatus == 1">离线</el-tag>
              <el-tag type="success" class="tag-online" v-if="addFormObject.deviceStatus == 2">在线</el-tag>
            </el-form-item>	  
          </el-col>
          <el-col :span="12">
            <el-form-item label="连接时间" prop="lastConnetTime">
              <span>{{addFormObject.lastConnetTime}}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div v-if="formTitle!='查看设备' && canEdit === 1" slot="footer" class="dialog-footer">
        <el-button @click="showAdd = false" class="cancel-btn">取消</el-button>
        <el-button type="primary" @click="addDeviceSub" class="save-btn">保存</el-button>
      </div>
    </el-dialog>

    <!-- 控制器数据详情弹窗 -->
    <el-dialog
      title="数据详情"
      :visible.sync="seekzqForm"
      top="2vh"
      width="90vw"
      custom-class="data-dialog"
    >
      <deviceOneVue :id="optId" v-if="seekzqForm" />
    </el-dialog>

    <!-- 电表数据详情弹窗 -->
    <el-dialog
      title="数据详情"
      :visible.sync="seedbForm"
      top="2vh"
      width="90vw"
      custom-class="data-dialog"
    >
      <deviceTwoVue :id="optId" v-if="seedbForm" />
    </el-dialog>
  </div>
</template>

<script>
import ManagementTable from '../../components/ManagementTable.vue';
import deviceOneVue from './deviceOne.vue';
import deviceTwoVue from './deviceTwo.vue';
import { getAccountPermission } from '../../utils/accountPermission';

export default {
  components: {
    ManagementTable,
    deviceOneVue,
    deviceTwoVue
  },
  data() {
    return {
      statusList: ["开机","关机","时间校正","清除历史数据","恢复出厂设置"],
      deviceList: [],
      canEdit: 1,
      seedbForm: false,
      optId: null,
      seekzqForm: false,
      allStationList: [],
      stationList: [],
      stationFilterList: [],
      formTitle: '添加设备',
      addFormObject: {
        deviceName: '',
        serNo: '',
        versionNo: '',
        typeNo: '',
        address: '',
        deviceType: null,
        id: 0,
        iccid: '',
        powerStationId: ''
      },
      // 表单中文校验规则 - 替换所有英文提示
      formRules: {
        deviceName: [{ required: true, message: '设备名称不能为空', trigger: 'blur' }],
        serNo: [{ required: true, message: '串号不能为空', trigger: 'blur' }],
        versionNo: [{ required: true, message: '版本号不能为空', trigger: 'blur' }],
        typeNo: [{ required: true, message: '型号不能为空', trigger: 'blur' }],
        address: [{ required: true, message: '设备地址不能为空', trigger: 'blur' }],
        deviceType: [{ required: true, message: '请选择设备类型', trigger: 'change' }],
        powerStationId: [{ required: true, message: '请选择电站', trigger: 'change' }]
        // iccid 已移除必填验证，允许为空
      },
      showAdd: false,
      loading: false,
      isMobileViewport: false,
      tableData: [],
      total: 0, 
      query: {
        pageNum: 1,
        pageSize: 9,
        stationId: '',
        id: '',
        stationType: '',
        deviceStatus: ''
      },
    }
  },
  mounted() {
    this.updateViewport();
    window.addEventListener('resize', this.updateViewport);
    this.canEdit = getAccountPermission();
    this.serch();
    this.loadStationList();
    this.loadAllList();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateViewport);
  },
  methods: {
    updateViewport() {
      this.isMobileViewport = window.innerWidth <= 760;
    },
    handleMobileCommand(command, row) {
      if (command === 'view') {
        this.formTitle = '查看设备';
        this.infoView(row.id);
        return;
      }
      if (command === 'edit') {
        this.formTitle = '编辑设备';
        this.infoView(row.id);
        return;
      }
      if (command === 'delete') {
        this.deleteRow(row.id);
        return;
      }
      if (command === 'controllerData') {
        this.optId = row.id;
        this.seekzqForm = true;
        return;
      }
      if (command === 'meterData') {
        this.optId = row.id;
        this.seedbForm = true;
        return;
      }
      if (command.indexOf('control:') === 0) {
        const index = Number(command.split(':')[1]);
        this.subEditForm(index + 1, row.serNo, this.statusList[index]);
      }
    },
    // 设备控制操作
    subEditForm(v, imei, actionName) {
      this.$confirm(`确认执行“${actionName}”操作吗？`, '设备控制确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'confirm-dialog'
      }).then(() => {
        const obj = { imei, optType: v };
        this.$request.post("/api/device/set/kzq/instruction", obj).then(response => {
          this.$message.success(response.data.message || "操作成功!");
        }).catch(err => {
          this.$message.error("网络异常，操作失败！");
        })
      }).catch(() => {});
    },
    // 加载设备名称下拉列表
    loadAllList() {
      const queryForm = { pageNum: 1, pageSize: 10000 };
      this.$request.post('/api/device/page', queryForm).then(response => {
        if (response.data.result) {
          this.deviceList = response.data.data.list;
        } else {
          this.$message.error("获取设备列表失败,请联系管理员!");
        }
      }).catch(err => {
        this.$message.error("网络异常，获取设备列表失败！");
      })
    },
    // 加载当前用户可访问的全部电站，不按设备绑定状态过滤
    loadStationList() {
      this.$request.get('/api/power/station/options').then(response => {
        if (response.data.result) {
          this.allStationList = response.data.data || [];
          this.stationList = this.allStationList.slice();
          this.stationFilterList = this.allStationList.slice();
        } else {
          this.$message.error("获取电站列表失败,请联系管理员!");
        }
      }).catch(err => {
        this.$message.error("网络异常，获取电站列表失败！");
      })	
    },
    // 表单提交 - 先校验再提交，规范简洁
    addDeviceSub() {
      this.$refs.formObjectForm.validate((valid) => {
        if (valid) {
          this.$request.post('/api/device/edit', this.addFormObject).then(response => {
            if (response.data.result) {
              this.serch();
              this.loadStationList();
              this.showAdd = false;
              this.$message.success(this.formTitle === "添加设备" ? "新增设备成功!" : "编辑设备成功!");
            } else {
              this.$message.error(response.data.message || "操作失败,请联系管理员!");
            }
          }).catch(err => {
            this.$message.error("网络异常，操作失败！");
          })
        } else {
          // 校验失败自动显示中文提示，无需额外处理
          return false;
        }
      })
    },
    // 删除设备
    deleteRow(id) {
      this.$confirm('确认删除此设备吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'confirm-dialog'
      }).then(() => {
        this.$request.delete(`/api/device/delete/${id}`).then(response => {
          if (response.data.result) {
            this.serch();
            this.$message.success("删除设备成功!");
          } else {
            this.$message.error(response.data.message || "删除失败,请联系管理员!");
          }
        }).catch(err => {
          this.$message.error("网络异常，删除失败！");
        })	
      }).catch(() => {});
    },
    // 查看/编辑设备
    infoView(id) {
      this.$request.get(`/api/device/info/${id}`).then(response => {
        if (response.data.result) {
          this.addFormObject = response.data.data;
          this.stationList = this.allStationList.slice();
          this.showAdd = true;
        } else {
          this.$message.error("获取设备详情失败,请联系管理员!");
        }
      }).catch(err => {
        this.$message.error("网络异常，获取设备详情失败！");
      })	
    },
    // 根据输入内容匹配电站名称中的任意位置
    filterStation(query) {
      const keyword = String(query || '').trim().toLocaleLowerCase();
      if (!keyword) {
        this.stationList = this.allStationList.slice();
        return;
      }
      this.stationList = this.allStationList.filter(item => {
        const stationName = String(item.stationName || '').toLocaleLowerCase();
        return stationName.includes(keyword);
      });
    },
    // 设备列表的电站筛选匹配名称中的任意位置
    filterSearchStation(query) {
      const keyword = String(query || '').trim().toLocaleLowerCase();
      this.stationFilterList = keyword ? this.allStationList.filter(item => {
        const stationName = String(item.stationName || '').toLocaleLowerCase();
        return stationName.includes(keyword);
      }) : this.allStationList.slice();
    },
    onSearchStationDropdownVisible(visible) {
      if (visible) this.stationFilterList = this.allStationList.slice();
    },
    // 新增设备
    addDevice() {
      this.addFormObject = {
        deviceName: '',
        serNo: '',
        versionNo: '',
        typeNo: '',
        address: '',
        deviceType: null,
        id: 0,
        iccid: '',
        powerStationId: ''
      };
      this.formTitle = '添加设备';
      this.loadStationList();
      this.showAdd = true;
      this.$nextTick(() => {
        if (this.$refs.formObjectForm) {
          this.$refs.formObjectForm.resetFields();
        }
      })
    },
    // 分页切换
    onPageChange(val) {
      this.query.pageNum = val;
      this.loadPage();
    },
    // 搜索
    serch() {
      this.query.pageNum = 1;
      this.loadPage();
    },
    // 加载列表
    loadPage() {
      this.loading = true;
      this.$request.post("/api/device/page", this.query).then(response => {
        if (response.data.result) {
          this.tableData = response.data.data.list;
          this.total = response.data.data.totalCount;
        } else {
          this.$message.error("获取设备列表失败,请联系管理员!");
        }
      }).catch(err => {
        this.$message.error("网络异常，获取设备列表失败！");
      }).finally(() => {
        this.loading = false;
      })
    },
    // 表格隔行变色
    tableRowClassName({ rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-light' : 'row-dark';
    }
  }
}
</script>

<style scoped>
.device-manage-page {
  width: 100%;
  height: 100%;
  min-height: 0;
}

/* 表格操作栏样式 */
.opt-group {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.opt-btn {
  color: var(--solar-primary, #387AFC);
  font-size: 14px;
  cursor: pointer;
  transition: color 0.3s;
}
.opt-btn:hover {
  color: var(--solar-primary, #00CCFF);
}
.del-btn {
  color: var(--solar-danger, #FF6B6B);
}
.del-btn:hover {
  color: var(--solar-danger, #FF4500);
}
.dropdown-btn {
  display: flex;
  align-items: center;
  gap: 4px;
}

.mobile-action-trigger {
  width: 58px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 0;
  border: 1px solid rgba(var(--solar-border-strong-rgb, 63, 184, 255), 0.56);
  border-radius: 5px;
  background: rgba(var(--solar-raised-rgb, 0, 72, 116), 0.72);
  color: var(--solar-text-strong, #bfeeff);
  font-size: 13px;
  cursor: pointer;
}

.mobile-action-trigger:focus,
.mobile-action-trigger:hover {
  border-color: var(--solar-border-strong, #00ccff);
  background: rgba(var(--solar-primary-rgb, 0, 111, 170), 0.86);
  color: var(--solar-text-strong, #ffffff);
  outline: none;
}

/* 设备控制弹层样式 */
.popover-content {
  background-color: var(--solar-surface, #002B4D) !important;
  border: 1px solid var(--solar-border, #003567) !important;
  padding: 8px 0 !important;
}
.popover-item {
  display: flex;
  align-items: center;
  min-height: 40px;
  box-sizing: border-box;
  color: var(--solar-text, #87CEFA) !important;
  padding: 10px 24px;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
}
.popover-item:hover {
  background-color: var(--solar-raised, #07527F) !important;
  color: var(--solar-text-strong, #FFFFFF) !important;
}

/* 核心：弹窗最外圈+内部全蓝色，彻底移除白色 */
:deep(.el-dialog) {
  --el-dialog-bg-color: var(--solar-on-primary, #002B4D) !important;
  --el-dialog-border-color: var(--solar-border, #003567) !important;
  --el-dialog-header-text-color: var(--solar-text, #87CEFA) !important;
}
:deep(.el-dialog__header) {
  background-color: var(--solar-page, #001A33) !important;
  border-bottom: 1px solid var(--solar-border, #003567) !important;
  padding: 16px 20px !important;
}
:deep(.el-dialog__title) {
  color: var(--solar-text, #87CEFA) !important;
  font-size: 16px !important;
}
:deep(.el-dialog__close) {
  color: var(--solar-text, #87CEFA) !important;
}
:deep(.el-dialog__close:hover) {
  color: var(--solar-primary, #00CCFF) !important;
}
:deep(.el-dialog__body) {
  background-color: var(--solar-surface, #002B4D) !important;
  padding: 20px !important;
}
/* 蓝色表单容器样式 */
:deep(.blue-form) {
  background-color: var(--solar-surface, #002B4D) !important;
  width: 100%;
}

/* 输入框/下拉框 全蓝色样式（无白色） */
:deep(.dialog-input), :deep(.dialog-select) {
  --el-input-bg-color: var(--solar-on-primary, #001A33) !important;
  --el-input-border-color: var(--solar-border, #003567) !important;
  --el-input-text-color: var(--solar-text, #87CEFA) !important;
  --el-input-placeholder-color: var(--solar-muted, #6699CC) !important;
  --el-select-bg-color: var(--solar-on-primary, #001A33) !important;
  --el-select-border-color: var(--solar-border, #003567) !important;
  --el-select-text-color: var(--solar-text, #87CEFA) !important;
  --el-select-placeholder-color: var(--solar-muted, #6699CC) !important;
  width: 100%;
}
:deep(.search-input.el-input),
:deep(.search-select.el-select),
:deep(.dialog-input.el-input),
:deep(.dialog-select.el-select) {
  height: 36px;
  border: 1px solid rgba(var(--solar-border-strong-rgb, 63, 184, 255), 0.58) !important;
  border-radius: 4px;
  background: rgba(var(--solar-page-rgb, 0, 18, 36), 0.72) !important;
  overflow: hidden;
  box-shadow: none !important;
  box-sizing: border-box;
}
:deep(.search-input.el-input:hover),
:deep(.search-input.el-input.is-focus),
:deep(.search-select.el-select:hover),
:deep(.search-select.el-select.is-focused),
:deep(.dialog-input.el-input:hover),
:deep(.dialog-input.el-input.is-focus),
:deep(.dialog-select.el-select:hover),
:deep(.dialog-select.el-select.is-focused) {
  border-color: rgba(var(--solar-border-strong-rgb, 63, 184, 255), 0.72) !important;
}
:deep(.el-input__wrapper), :deep(.el-select__wrapper) {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
}
:deep(.el-input__wrapper:hover),
:deep(.el-input__wrapper.is-focus),
:deep(.el-select__wrapper:hover),
:deep(.el-select__wrapper.is-focused),
:deep(.el-select .el-input.is-focus .el-input__wrapper) {
  border: 0 !important;
  box-shadow: none !important;
}
:deep(.el-select .el-input > .el-input__inner),
:deep(.search-input > .el-input__inner),
:deep(.search-select .el-input > .el-input__inner) {
  height: 36px;
  line-height: 36px;
  border: 0 !important;
  background: transparent !important;
  color: var(--solar-text-strong, #dff8ff) !important;
  box-shadow: none !important;
}
:deep(.el-select) {
  width: 100%;
}
:deep(.el-input__wrapper .el-input__inner),
:deep(.el-select__wrapper .el-input__inner) {
  border: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}
:deep(.el-select__placeholder), :deep(.el-select__label) {
  color: var(--solar-text, #87CEFA) !important;
}

/deep/ .search-input .el-input,
/deep/ .search-select .el-select,
/deep/ .search-select .el-input {
  border: 0 !important;
  box-shadow: none !important;
}

/deep/ .search-input.el-input,
/deep/ .search-select.el-select,
/deep/ .dialog-input.el-input,
/deep/ .dialog-select.el-select {
  height: 36px;
  border: 1px solid rgba(var(--solar-border-strong-rgb, 63, 184, 255), 0.58) !important;
  border-radius: 4px;
  background: rgba(var(--solar-page-rgb, 0, 18, 36), 0.72) !important;
  overflow: hidden;
  box-shadow: none !important;
  box-sizing: border-box;
}

/deep/ .search-input .el-input__wrapper,
/deep/ .search-select .el-input__wrapper,
/deep/ .search-select .el-select__wrapper,
/deep/ .search-input .el-input__wrapper:hover,
/deep/ .search-select .el-input__wrapper:hover,
/deep/ .search-input .el-input__wrapper.is-focus,
/deep/ .search-select .el-input__wrapper.is-focus,
/deep/ .search-select .el-select__wrapper:hover,
/deep/ .search-select .el-select__wrapper.is-focused,
/deep/ .search-select .el-input.is-focus .el-input__wrapper {
  border: 0 !important;
  box-shadow: none !important;
}

/deep/ .search-input > .el-input__inner,
/deep/ .search-select .el-input > .el-input__inner {
  height: 36px !important;
  line-height: 36px !important;
  border: 0 !important;
  background: transparent !important;
  color: var(--solar-text-strong, #dff8ff) !important;
  box-shadow: none !important;
}

/deep/ .search-input .el-input__wrapper .el-input__inner,
/deep/ .search-select .el-input__wrapper .el-input__inner,
/deep/ .search-select .el-select__wrapper .el-input__inner {
  height: 36px !important;
  line-height: 36px !important;
  border: 0 !important;
  background: transparent !important;
  color: var(--solar-text-strong, #dff8ff) !important;
  box-shadow: none !important;
}

/* 表单标签+必填星号+中文校验提示样式 */
:deep(.el-form-item__label) {
  color: var(--solar-text, #87CEFA) !important;
}
:deep(.el-form-item__required) {
  color: var(--solar-primary, #00CCFF) !important;
}
:deep(.el-form-item__error) {
  color: var(--solar-danger, #FF4500) !important;
  font-size: 12px !important;
}

/* 校验提示靠近所属输入框，并与下一行输入框保持清晰间距 */
.blue-form /deep/ .el-form-item__error {
  padding-top: 2px;
}
.blue-form /deep/ .el-form-item.is-error {
  margin-bottom: 38px;
}

/* 弹窗按钮组样式 */
.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 20px;
}
.cancel-btn {
  --el-button-bg-color: var(--solar-on-primary, #003567);
  --el-button-border-color: var(--solar-border, #003567);
  --el-button-text-color: var(--solar-text, #87CEFA);
  --el-button-hover-bg-color: var(--solar-on-primary, #00407F);
}
.save-btn {
  --el-button-bg-color: var(--solar-primary, #0099FF);
  --el-button-hover-bg-color: var(--solar-primary, #0066CC);
  --el-button-text-color: var(--solar-on-primary, #002B4D);
  --el-button-border-color: var(--solar-border-strong, #0099FF);
}

:deep(.save-btn.el-button) {
  color: var(--solar-on-primary, #002B4D) !important;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
}

:deep(.cancel-btn.el-button) {
  color: var(--solar-text, #87CEFA) !important;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
}

/* 数据详情弹窗 同步蓝色样式 */
:deep(.data-dialog) {
  --el-dialog-bg-color: var(--solar-on-primary, #002B4D) !important;
  --el-dialog-border-color: var(--solar-border, #003567) !important;
  --el-dialog-header-text-color: var(--solar-text, #87CEFA) !important;
}
:deep(.data-dialog .el-dialog__header) {
  background-color: var(--solar-page, #001A33) !important;
  border-bottom: 1px solid var(--solar-border, #003567) !important;
}

:deep(.data-dialog .el-dialog__body) {
  height: calc(96vh - 56px);
  padding: 0 !important;
  box-sizing: border-box;
  overflow: hidden;
}

:deep(.data-dialog .device-overview-container) {
  height: 100%;
}

:deep(.data-dialog .device-overview-panel) {
  height: calc(100% - 48px);
  max-height: calc(100% - 48px);
}

/* 状态标签样式 */
:deep(.tag-online) {
  --el-tag-bg-color: #00A40C;
  --el-tag-text-color: var(--solar-text-strong, #FFFFFF);
}
:deep(.tag-offline) {
  --el-tag-bg-color: var(--solar-danger, #FF4500);
  --el-tag-text-color: var(--solar-text-strong, #FFFFFF);
}

/* 滚动条 蓝色系适配 */
:deep(::-webkit-scrollbar) {
  width: 6px;
  height: 6px;
  background-color: var(--solar-page, #001A33);
}
:deep(::-webkit-scrollbar-thumb) {
  background-color: var(--solar-primary, #0099FF);
  border-radius: 3px;
}
:deep(::-webkit-scrollbar-track) {
  background-color: var(--solar-surface, #002B4D);
  border-radius: 3px;
}

@media (max-width: 760px) {
  /*
   * Element UI 会根据滚动条宽度定位右侧固定列。在移动端的覆盖式
   * 滚动条环境中，计算结果会在最右侧留下细缝，露出下层滚动列。
   * 强制贴紧右边缘，并用实色封住最后 1px，避免亚像素取整产生漏底。
   */
  /deep/ .device-index-table .el-table__fixed-right {
    right: 0 !important;
    background-color: var(--solar-surface, #002b4d) !important;
  }

  /deep/ .device-index-table .el-table__fixed-right::after {
    position: absolute;
    z-index: 4;
    top: 0;
    right: -1px;
    bottom: 0;
    width: 2px;
    background-color: var(--solar-surface, #002b4d);
    content: '';
    pointer-events: none;
  }

  /deep/ .device-dialog {
    background-color: var(--solar-surface, #002B4D) !important;
  }

  /deep/ .device-dialog .el-dialog__body {
    padding: 16px 14px !important;
  }

  /deep/ .device-dialog .el-col-12 {
    width: 100%;
  }

  /deep/ .device-dialog .el-form-item {
    margin-bottom: 16px;
  }

  /deep/ .device-dialog .el-form-item__label {
    float: none;
    height: auto;
    padding: 0 0 7px;
    line-height: 20px;
  }

  /deep/ .device-dialog .el-form-item__content {
    margin-left: 0 !important;
  }

  /deep/ .device-dialog .dialog-input.el-input,
  /deep/ .device-dialog .dialog-select.el-select,
  /deep/ .device-dialog .dialog-input > .el-input__inner,
  /deep/ .device-dialog .dialog-select .el-input > .el-input__inner {
    height: 42px !important;
    line-height: 42px !important;
  }

  .blue-form /deep/ .el-form-item.is-error {
    margin-bottom: 28px;
  }

  .dialog-footer {
    gap: 12px;
  }

  .dialog-footer .el-button {
    flex: 1;
    min-width: 0;
    min-height: 42px;
    margin-left: 0;
  }
}

</style>

<!-- MessageBox 挂载在 body 下，需要使用非 scoped 样式 -->
<style>
.device-dialog.el-dialog {
  background-color: var(--solar-surface, #002B4D) !important;
}

/* 查看模式下弱化字段名、提亮字段值；使用非 scoped 规则以命中 Element UI 弹窗内容。 */
.device-dialog .detail-view-form .el-form-item__label {
  color: var(--solar-muted, #7faec4) !important;
}

.device-dialog .detail-view-form .el-form-item__content {
  color: var(--solar-text-strong, #e6f7ff) !important;
}

.device-dialog .el-dialog__footer {
  padding: 15px 20px;
  border-top: 1px solid rgba(var(--solar-border-strong-rgb, 63, 184, 255), 0.24);
  background-color: var(--solar-page, #001A33) !important;
}

.confirm-dialog.el-message-box {
  border: 1px solid rgba(var(--solar-border-strong-rgb, 63, 184, 255), 0.45);
  background-color: var(--solar-surface, #032B4B);
  box-shadow: 0 20px 60px rgba(0, 7, 18, 0.56);
}
.confirm-dialog .el-message-box__title,
.confirm-dialog .el-message-box__message,
.confirm-dialog .el-message-box__close {
  color: var(--solar-text-strong, #C9EFFF);
}
.confirm-dialog .el-button--default {
  border-color: rgba(var(--solar-border-strong-rgb, 63, 184, 255), 0.45);
  background-color: var(--solar-surface, #052F50);
  color: var(--solar-text-strong, #AEE7FF);
}
.confirm-dialog .el-button--default:hover,
.confirm-dialog .el-button--default:focus {
  border-color: var(--solar-border-strong, #00CCFF);
  background-color: var(--solar-raised, #07527F);
  color: var(--solar-text-strong, #FFFFFF);
}
.confirm-dialog .el-button--primary {
  border-color: var(--solar-border-strong, #168DE2);
  background-color: var(--solar-primary, #168DE2);
  color: var(--solar-text-strong, #FFFFFF);
}
.confirm-dialog .el-button--primary:hover,
.confirm-dialog .el-button--primary:focus {
  border-color: var(--solar-border-strong, #00CCFF);
  background-color: var(--solar-primary, #0879BD);
}

.device-mobile-actions-menu.el-dropdown-menu {
  min-width: 156px;
  padding: 6px 0;
  border-color: rgba(var(--solar-border-strong-rgb, 63, 184, 255), 0.5);
  background: var(--solar-surface, #032b4b);
  box-shadow: 0 14px 34px rgba(0, 7, 18, 0.52);
}

.device-mobile-actions-menu .el-dropdown-menu__item {
  min-height: 40px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  color: var(--solar-text-strong, #bfeeff);
  line-height: 20px;
}

.device-mobile-actions-menu .el-dropdown-menu__item:hover,
.device-mobile-actions-menu .el-dropdown-menu__item:focus {
  background: var(--solar-raised, #07527f);
  color: var(--solar-text-strong, #ffffff);
}

.device-mobile-actions-menu .el-dropdown-menu__item--divided {
  border-top-color: rgba(var(--solar-border-strong-rgb, 63, 184, 255), 0.22);
}

.device-mobile-actions-menu .el-dropdown-menu__item--divided::before {
  position: absolute;
  top: -7px;
  right: 0;
  left: 0;
  height: 6px;
  margin: 0;
  background: var(--solar-surface, #032b4b);
}

.device-mobile-actions-menu .device-mobile-delete-action {
  color: var(--solar-danger, #ff8b8b);
}
</style>
